import { ActionTypes } from "../constantes/ActionTypes";
import axios from "../../../../common/axios";

export const portsStart = (action) => {
  return (dispatch) => {
    dispatch(action);
    axios
      .get(
        `/getPortsList`
      )
      .then((response) => {
        dispatch(portsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(portsFailed(error.response?.data));
      });
  };
};

export const portsSuccess = (portsList) => {
  return {
    type: ActionTypes.ACTION_PORTS_SUCCESS,
    payload: portsList,
  };
};

export const portsFailed = (error) => {
  return {
    type: ActionTypes.ACTION_PORTS_FAILED,
    payload: error,
  };
};

export const shipmentInfoInit = () => {
  return {
    type: ActionTypes.ACTION_PORTS_INIT,
    payload: "",
  };
};
